// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "/* TAG STATUS */\n/* VIEW */\n.recipients-list[data-v-7e2143ce] {\n  list-style-type: none;\n  padding: 0;\n}\n.recipients-list li[data-v-7e2143ce] {\n  margin-top: 3px;\n  margin-bottom: 15px;\n}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
